import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { HumanInteractionService } from '../../../../services/human-interaction.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {WfTableComponent} from '../../../../common/table-sort/wf-table.component';
import {Subject} from 'rxjs';
import {CustomValidator} from '../../../../services/custom-validator';

@Component({
  selector: 'app-edit-queue-color-modal',
  templateUrl: './edit-queue-color-modal.component.html',
  styleUrls: ['./edit-queue-color-modal.component.css']
})
export class EditQueueColorModalComponent implements OnInit {

  @Input() modalTitle: string;
  error = '';
  fieldError = '';
  objInitialState: any;
  colorForm: FormGroup;
  colorInfo;
  availableBusinessProcessList;
  availableStates;
  isCustom = false;
  businessProcessFieldList;
  itemSaved: Subject<any> = new Subject();



  get formData() { return this.colorForm.controls; }
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;
  get slaColor(){
    if (this.formData) {
      return this.formData.color.value;
    }
    return null;
  };
  set slaColor(value){
    this.colorForm.get('color').setValue(value);
  };

  constructor(
    private humanInteractionService: HumanInteractionService,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.colorInfo = this.objInitialState.color;
    this.availableBusinessProcessList = this.objInitialState.bps;
    if (this.objInitialState.isCustom) {
      this.isCustom = this.objInitialState.isCustom;
    }
    this.createForm();
    this.loadData();
  }

  createForm() {
    this.colorForm = this.formBuilder.group({
      businessProcessId: [0, Validators.min(1)],
      stateId: [0, Validators.min(1)],
      initialSeconds: [0, [Validators.min(1), Validators.max(2147482), CustomValidator.numeric]],
      color: [null, CustomValidator.trimRequired]
    });

    if (this.isCustom) {
      this.colorForm.get('businessProcessId').clearValidators();
      this.colorForm.get('stateId').clearValidators();
    }
  }

  loadData() {
    if (!this.colorInfo){
      return;
    }
    this.colorForm.patchValue({
      businessProcessId: this.colorInfo.businessProcessId,
      stateId: this.colorInfo.stateId,
      initialSeconds: this.colorInfo.initialSeconds,
      color: this.colorInfo.color
    });

    if (!this.isCustom) {
      this.onBpChange();
      this.colorForm.get('businessProcessId').setValue(this.colorInfo.businessProcessId);
      this.colorForm.get('stateId').setValue(this.colorInfo.stateId);
      this.colorForm.updateValueAndValidity();
    }

    //this.refreshBusinessProcessFieldTable();
  }

  onBpChange() {
    let bpId = this.formData.businessProcessId.value;
    let bp = this.availableBusinessProcessList.filter(bp => bp.businessProcessId == bpId);
    this.availableStates = bp[0].states;
    if (bp[0].states.filter(f => f.stateId == 0).length == 0) {
      this.availableStates.push({stateId:0, name:''});
    }
    this.colorForm.get('stateId').setValue(0);
  }

  onClickOk() {
    let raw = this.colorForm.getRawValue();
    let response = {oldColor: this.colorInfo, newColor:raw}
    this.itemSaved.next(response);
    this.bsModalRef.hide();
  }

  onClose() {
    this.bsModalRef.hide();
  }
}
